import { render } from "./CreateMaterialFromInv.vue?vue&type=template&id=22352d41&scoped=true"
import script from "./CreateMaterialFromInv.vue?vue&type=script&lang=js"
export * from "./CreateMaterialFromInv.vue?vue&type=script&lang=js"

import "./CreateMaterialFromInv.vue?vue&type=style&index=0&id=22352d41&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22352d41"]])

export default __exports__